import { TabVIewerDesktop } from './tabViewerDesktop';
import { TabViewerMobile } from './tabViewerMobile';
import { useTab } from './useTab';

export const TableTabs = ({ tabs }: { tabs?: string[] }) => {
  const { activeTabInfo } = useTab(tabs);

  if (!activeTabInfo || !tabs?.length) {
    return null;
  }
  return (
    <div className="flex flex-col gap-6 p-4 pl-0 md:px-0">
      {activeTabInfo ? (
        <h3 className="mhg-alpha-typography-display-1">{activeTabInfo}</h3>
      ) : null}
      <TabVIewerDesktop tabs={tabs} />
      <TabViewerMobile tabs={tabs} />
    </div>
  );
};
